import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSticker: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"sticker, badge"} maskId="square-filled-radius-0-stroke-1-IconSticker"><path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C12.1764 2 12.3517 2.00457 12.5259 2.0136L12.7177 2.02355L21.9764 11.2823L21.9864 11.4741C21.9954 11.6483 22 11.8236 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM21 11.9444C15.9419 12.5538 11.4462 8.0579 12.0555 3L21 11.9444Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSticker;
